import { adStats } from '../../../mocks/adPlacements';

export default function AdPerformanceStats() {
  return (
    <section className="py-16 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">Platform Performance</h2>
          <p className="text-gray-600">Real-time advertising metrics from current campaigns</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-xl p-6 border border-emerald-100">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-600 text-white rounded-lg">
                <i className="ri-layout-grid-line text-xl"></i>
              </div>
              <span className="text-xs font-semibold text-emerald-700 bg-emerald-100 px-2 py-1 rounded-full">
                {Math.round((adStats.occupiedSlots / adStats.totalSlots) * 100)}% Occupied
              </span>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-1">
              {adStats.availableSlots}/{adStats.totalSlots}
            </div>
            <div className="text-sm text-gray-600">Available Ad Slots</div>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-100">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-600 text-white rounded-lg">
                <i className="ri-money-dollar-circle-line text-xl"></i>
              </div>
              <span className="text-xs font-semibold text-blue-700 bg-blue-100 px-2 py-1 rounded-full">
                This Month
              </span>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-1">
              ${adStats.monthlyRevenue.toLocaleString()}
            </div>
            <div className="text-sm text-gray-600">Monthly Revenue</div>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 border border-purple-100">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-600 text-white rounded-lg">
                <i className="ri-eye-line text-xl"></i>
              </div>
              <span className="text-xs font-semibold text-purple-700 bg-purple-100 px-2 py-1 rounded-full">
                Last 30 Days
              </span>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-1">
              {(adStats.totalImpressions / 1000).toFixed(0)}K
            </div>
            <div className="text-sm text-gray-600">Total Impressions</div>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-6 border border-orange-100">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-600 text-white rounded-lg">
                <i className="ri-cursor-line text-xl"></i>
              </div>
              <span className="text-xs font-semibold text-orange-700 bg-orange-100 px-2 py-1 rounded-full">
                Average
              </span>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-1">
              {adStats.averageCTR}%
            </div>
            <div className="text-sm text-gray-600">Click-Through Rate</div>
          </div>
        </div>

        {/* Top Performer Highlight */}
        <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-xl p-8 text-white">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-lg">
              <i className="ri-trophy-line text-2xl"></i>
            </div>
            <div>
              <div className="text-sm text-white/80 mb-1">Top Performing Placement</div>
              <div className="text-2xl font-bold">{adStats.topPerformer.name}</div>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="text-sm text-white/80 mb-1">Current Advertiser</div>
              <div className="font-semibold">{adStats.topPerformer.advertiser}</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="text-sm text-white/80 mb-1">Click-Through Rate</div>
              <div className="text-2xl font-bold">{adStats.topPerformer.ctr}%</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20">
              <div className="text-sm text-white/80 mb-1">Performance</div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold">
                  {Math.round((adStats.topPerformer.ctr / adStats.averageCTR - 1) * 100)}%
                </span>
                <span className="text-sm">above average</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}